'use client';

import {createProvidedStore} from '@utils/createProvidedStore';
import createZustandStore from '@utils/createZustandStore';

interface IUpdateChapterMeta {
    videoId?: number;
    activeChapterTimestamp?: number;
}

interface IChaptersStore {
    videoId: number | undefined;
    activeChapterTimestamp: number;

    updateChapterMeta: (params: IUpdateChapterMeta) => void;
}

export const createChaptersStore = (initState?: Partial<IChaptersStore>) =>
    createZustandStore<IChaptersStore>(set => ({
        videoId: undefined,
        activeChapterTimestamp: 0,
        ...initState,

        updateChapterMeta: async ({videoId, activeChapterTimestamp}) => {
            set(state => {
                state.videoId = videoId ?? state.videoId;
                state.activeChapterTimestamp =
                    activeChapterTimestamp ?? state.activeChapterTimestamp;
            });
        },
    }));

const store = createProvidedStore(createChaptersStore);
export const useChaptersStore = store.useStore;
export const ChaptersStoreProvider = store.StoreProvider;
